import Http from '@/services/http'
/*
  小文件上传
*/
export const upload = (params: { file: any }, cb: any) => {
  return Http.upload(
    {
      url: '/cwhCopilot/copilot/v1/resource/attach/upload?time' + Date.now(),
      params
    },
    cb
  )
}

export const getMessageTotal = (params?: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/authority/item/getTotal/${params.macId}`,
    params,
    method: 'get'
  })
}

export const getDigitalDetail = (params?: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/role/item/getDigitalManId/${params.digitalManId}`,
    params,
    method: 'get'
  })
}
export const getDigitalDetailV2 = (params?: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/faq/role/item/getDigitalManId/${params.digitalManId}`,
    params,
    method: 'get'
  })
}

export const filterWord = (params?: any) => {
  return Http.request({
    url: `/cwhCopilot/copilot/v1/authority/item/checkSensitiveWord`,
    params,
    method: 'post'
  })
}
